export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
               
        $('#menu-main-menu').find('.dropdown').each(function() {
            $(this).children('a').each(function() {
                var url = $(this).attr('href');
                if (url !== '#') {
                    $(this).attr('data-url', url);
                    // $(this).attr('href','#');
                }
            });
        });
        $('#menu-main-menu li.dropdown > a').click(function(e) {
            if ($(window).width() < 1025) {
                var grandparent = $(this).next();
                if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
                    document.location.href = this.href;
                } else {
                    $(this).addClass('open1');
                    $('#menu-main-menu').find('i').removeClass('opened');
                    $(this).next('.dropdown-toggle1').click();
                }
            } else {
                location.href = this.href;
            }
            e.preventDefault();
        });
        $('li.dropdown > .dropdown-toggle1').on('click', function(e) {
            var current = $(this).next();
            var current1 = $(this);
            var grandparent = $(this).parent().parent();
            grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
            grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
            grandparent.addClass('open1111');
            $(this).toggleClass('opened');
            current.toggleClass('show1');
            e.stopPropagation();
        });
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            if (scroll >= 100) {
                $('.sticky-site-header').addClass('shadow_css');
            } else {
                $('.sticky-site-header').removeClass('shadow_css');
            }
        });
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js